import React from 'react';
import {
  Button,
  ButtonProps,
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import {
  Code20,
  DocumentPdf20,
  Download20,
  Table20,
} from '@carbon/icons-react';
import { PulseLoader } from 'react-spinners';
import DownloadLink from '#coreComponents/DownloadLink';
import { usePermissions } from '#core/Permissions';
// JME
// import { useAuthHook } from '#utils/useAuthHook';
// JME1
import { useAuth } from '#core/Auth';
import { usePageQuery } from '#core/PageQuery';
import { useInstitution } from '#core/Institution';

const MenuButtonAsButton = MenuButton as React.FC<
  MenuButtonProps & ButtonProps
>;

export type DownloadURLs = {
  xlsx?: string;
  csv?: string;
  methodology?: string;
};

export type DownloadParams = {
  [key: string]: string | number | boolean | (string | number)[] | undefined;
};
const DownloadDropdown = ({
  urls,
  params,
  loading,
}: {
  urls: DownloadURLs;
  params: DownloadParams;
  loading?: boolean;
}) => {
  const {
    query: { selectedYear: year },
  } = usePageQuery();
  const { institution } = useInstitution();
  const { hasResourcePermissionNew } = usePermissions();
  const { useElevatedPermissions } = useAuth(); // JME2

  const hasDownloadPermissionForExplore = hasResourcePermissionNew({
    action: 'dataplus:export',
    year,
    institutionId: institution?.institutionId,
  });

  const hasDownloadPermissionForWurReporterInterim = hasResourcePermissionNew({
    action: 'wurReporterInterim:viewPage',
    year,
    institutionId: institution?.institutionId,
  });

  return (
    <Menu>
      <MenuButtonAsButton
        as={Button}
        rightIcon={
          loading ? <PulseLoader color="#d69e2e" size="4px" /> : <Download20 />
        }
        bg="white"
        border={'1px'}
        _hover={{ bg: 'gray.100' }}
        _active={{ bg: 'gray.100' }}
        fontWeight="bold"
        display={{ base: 'none', lg: 'inline-flex' }}
        disabled={
          !hasDownloadPermissionForExplore &&
          !useElevatedPermissions &&
          !hasDownloadPermissionForWurReporterInterim
        }
      >
        Download
      </MenuButtonAsButton>
      {!loading && (
        <MenuList
          placement="bottom-start"
          bg="gray.700"
          color="gray.100"
          borderColor="gray.800"
        >
          {urls?.xlsx && (
            <MenuItem
              _hover={{ bg: 'gray.800' }}
              _active={{ bg: 'gray.800' }}
              _focus={{ bg: 'gray.800' }}
            >
              <DownloadLink fileType="xlsx" url={urls.xlsx} params={params}>
                Excel
                <Table20 />
              </DownloadLink>
            </MenuItem>
          )}
          {urls?.csv && (
            <MenuItem
              _hover={{ bg: 'gray.800' }}
              _active={{ bg: 'gray.800' }}
              _focus={{ bg: 'gray.800' }}
            >
              <DownloadLink fileType="csv" url={urls.csv} params={params}>
                CSV
                <Code20 />
              </DownloadLink>
            </MenuItem>
          )}
          {urls?.methodology && (
            <MenuItem
              _hover={{ bg: 'gray.800' }}
              _active={{ bg: 'gray.800' }}
              _focus={{ bg: 'gray.800' }}
            >
              <DownloadLink
                fileType="methodology"
                url={urls.methodology}
                params={params}
              >
                Methodology
                <DocumentPdf20 />
              </DownloadLink>
            </MenuItem>
          )}
        </MenuList>
      )}
    </Menu>
  );
};

export default DownloadDropdown;
